module.exports = __webpack_public_path__ + "img/collection-engagementRingsExclusive.089d5ff.webp";